import styles from './defaultSelect.module.css';
import { CustomSelectProps } from './Select';

const DefaultStyledSelect = (props: CustomSelectProps) => {
  const { selectContainer, selectContainerDisabled, select } = styles;
  const classNames = props.disabled ? `${selectContainer} ${selectContainerDisabled}` : selectContainer;

  return (
    <div className={`${classNames}`}>
      <select {...props} className={select}>
        {props.options?.map(({ value, label }) =>
          <option key={value || label} value={value || undefined}>{label}</option>
        )}
      </select>
    </div>
  )
}

export default DefaultStyledSelect;
